<template>
  <a-card :bordered="false">
    <!-- 远传表系统-考核流量计历史数据 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <!-- <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>-->
          <!-- 水司查询 -->
          <a-col :md="4" :sm="12">
            <a-form-item label="水表编码">
              <a-input allow-clear v-model="query.flowMeterNo" placeholder="请输入水表编码" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item label="厂商名称">
              <a-select placeholder="请选择厂商名称" v-model="query.factory" allow-clear>
                <a-select-option v-for="item in manuList" :value="item" :key="item">{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="采集开始-结束时间">
              <a-range-picker v-model="collectionTime" :show-time="{ format: 'HH:mm:ss' }" format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['采集开始时间', '采集结束时间']" @change="collectionOnChange" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="12">
            <a-form-item label="推送开始-结束时间">
              <a-range-picker :show-time="{ format: 'HH:mm:ss' }" format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['推送开始时间', '推送结束时间']" @change="pushOnChange" v-model="pushTime" />
            </a-form-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <!-- <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()">新增</a-button> -->
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button style="margin-left: 8px" @click="exportHandle()" type="primary" v-action:export>导出</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table size="middle" rowKey="id" :scroll="{ x: 2100 }" bordered
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange"></a-table>
  </a-card>
</template>

<script>
import axios from 'axios'
import mixinViewModule from '@/mixin/common'
import { PERMISSION_ENUM } from '@/core/permission/permission'

const columns = [
  {
    title: '水表名称',
    dataIndex: 'flowMeterName'
  },
  {
    title: '水表厂商',
    dataIndex: 'factory'
  },
  {
    title: '水表口径',
    dataIndex: 'diameter'
  },
  {
    title: '安装地址',
    dataIndex: 'address'
  },
  {
    title: '水表编码',
    dataIndex: 'flowMeterNo'
  },
  {
    title: '瞬时流量',
    dataIndex: 'flowRate'
  },
  {
    title: '正向累积值',
    dataIndex: 'forwardFlow'
  },
  {
    title: '反向累积值',
    dataIndex: 'reverseFlow'
  },
  {
    title: '信号强度',
    dataIndex: 'signalStrength'
  },
  {
    title: '计量电池',
    dataIndex: 'meteringBattery'
  },
  {
    title: '通讯电池',
    dataIndex: 'communicationBattery'
  },
  {
    title: '通讯电压',
    dataIndex: 'communicationVoltage'
  },
  {
    title: '计量电压',
    dataIndex: 'meterVoltage'
  },
  {
    title: '采集时间',
    dataIndex: 'collectTime',
    scopedSlots: { customRender: '  collectTime' }
  },
  {
    title: '推送时间',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  }
  // {
  //   title: '操作',
  //   width: '150px',
  //   dataIndex: 'action',
  //   scopedSlots: { customRender: 'action' }
  // }
]

export default {
  components: {},
  mixins: [mixinViewModule],
  name: 'WaterMeterHistory',
  data () {
    return {
      collectionTime: [],
      pushTime: [],
      manuList: [],
      exportDataUrl: 'pipe-network/meter-history/export',
      exportFileName: '考核流量计历史数据.xlsx',
      queryUrl: 'pipe-network/meter-history/page',
      queryOneUrl: 'pipe-network/meter-history',
      deleteUrl: 'pipe-network/meter-history',
      query: {
        flowMeterNo: '',
        factory: '',
        collectBeginTime: '',
        collectEndTime: '',
        // tenantId: this.$store.state.user.info.tenantId,     //水司查询
        beginTime: '',
        endTime: ''
      },
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      columns
    }
  },
  // filters: {
  //   statusFilter (key) {
  //     return STATUS[key]
  //   },
  //   permissionFilter (key) {
  //     const permission = PERMISSION_ENUM[key]
  //     return permission && permission.label
  //   }
  // },
  created () {
    this.getManufacturer()
    this.resetList()
    // this.getAllTenant()   //水司查询
  },
  methods: {
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRowKeys = []
      this.loadData()
    },
    // 导出
    exportHandle () {
      this.exportLoading = true
      const params = {
        responseType: 'arraybuffer',
        params: {
          ...this.query,
          limit: this.pagination.pageSize,
          page: this.pagination.current,
          orderColumn: this.orderColumn,
          orderType: this.orderType
        },
        headers: this.uploadHeader
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then(res => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '考核流量计历史数据.xlsx'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    // 重置
    resetList () {
      this.pushTime = []
      this.collectionTime = []
      this.query = {}
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
      console.log(this.pushTime)
    },
    // 获取获取水司厂商选项
    getManufacturer () {
      this.$http.get('pipe-network/meter-history/factory/option').then(res => {
        if (res.code == 0) {
          this.manuList = res.data
        }
        //  if (this.needPage) {
        //   this.list = data.list || []
        //   this.pagination.total = data.total ? parseInt(data.total) : 0
        //   console.log(this.list)
        // }
      })
    },
    pushOnChange (value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
    },
    collectionOnChange (value, dateString) {
      this.query.collectBeginTime = dateString[0]
      this.query.collectEndTime = dateString[1]
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
